"use client";

/**
 * Brand domain 404 page.
 * 
 * Shown when a subdomain/store doesn't exist or when the brand is inactive.
 * Matches the dark premium design of the maintenance page.
 */

export default function BrandNotFound() {
    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(160deg, #0a0a1a 0%, #0d0d1f 40%, #0a0e1a 100%)",
                fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
                padding: "24px",
                position: "relative",
                overflow: "hidden",
                color: "#e2e8f0",
            }}
        >
            {/* Background glow */}
            <div
                style={{
                    position: "absolute",
                    top: "20%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "700px",
                    height: "500px",
                    borderRadius: "50%",
                    background: "rgba(99,102,241,0.10)",
                    filter: "blur(120px)",
                    pointerEvents: "none",
                }}
            />

            {/* Card */}
            <div
                style={{
                    position: "relative",
                    maxWidth: "520px",
                    width: "100%",
                    background: "rgba(255,255,255,0.03)",
                    border: "1px solid rgba(255,255,255,0.06)",
                    borderRadius: "20px",
                    padding: "48px 40px 36px",
                    backdropFilter: "blur(16px)",
                    textAlign: "center",
                    boxShadow:
                        "0 30px 80px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.04)",
                }}
            >
                {/* 404 Number */}
                <div
                    style={{
                        fontSize: "80px",
                        fontWeight: 800,
                        lineHeight: 1,
                        marginBottom: "16px",
                        background: "linear-gradient(135deg, #6366f1, #818cf8, #a5b4fc)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        letterSpacing: "-4px",
                    }}
                >
                    404
                </div>

                <h1
                    style={{
                        fontSize: "22px",
                        fontWeight: 700,
                        color: "#e2e8f0",
                        marginBottom: "12px",
                    }}
                >
                    Store Not Found
                </h1>

                <p
                    style={{
                        fontSize: "14px",
                        color: "#94a3b8",
                        lineHeight: 1.7,
                        marginBottom: "8px",
                    }}
                >
                    The store you&apos;re looking for doesn&apos;t exist or may have been moved.
                </p>
                <p
                    style={{
                        fontSize: "12px",
                        color: "#64748b",
                        lineHeight: 1.6,
                        marginBottom: "28px",
                    }}
                >
                    Double-check the URL or explore our marketplace to find what you need.
                </p>

                {/* Refresh Page */}
                <button
                    onClick={() => window.location.reload()}
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        width: "100%",
                        padding: "13px 24px",
                        borderRadius: "10px",
                        background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: "14px",
                        border: "none",
                        cursor: "pointer",
                        marginBottom: "12px",
                        boxShadow: "0 4px 20px rgba(99,102,241,0.25)",
                    }}
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 2v6h-6"></path><path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path><path d="M3 22v-6h6"></path><path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                    </svg>
                    Refresh Page
                </button>

                {/* Contact Support */}
                <button
                    onClick={() =>
                        window.open(
                            "https://wa.me/256780063058?text=Hi%2C%20I%20can%27t%20find%20a%20store%20I%27m%20looking%20for.",
                            "_blank"
                        )
                    }
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        padding: "11px 24px",
                        borderRadius: "10px",
                        background: "transparent",
                        color: "#94a3b8",
                        fontWeight: 500,
                        fontSize: "13px",
                        border: "1px solid rgba(255,255,255,0.08)",
                        cursor: "pointer",
                        width: "100%",
                    }}
                >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path
                            d="M13 9.667A1.333 1.333 0 0111.667 11H3.667L1 13.667V3.333A1.333 1.333 0 012.333 2h9.334A1.333 1.333 0 0113 3.333v6.334z"
                            stroke="#94a3b8"
                            strokeWidth="1.2"
                            fill="none"
                        />
                    </svg>
                    Contact Support
                </button>
            </div>

            {/* Footer */}
            <div
                style={{
                    maxWidth: "520px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "24px",
                    padding: "0 8px",
                    fontSize: "11px",
                    color: "#334155",
                    fontFamily: "monospace",
                }}
            >
                <span>Kuttos Technologies</span>
                <span>Error: 404</span>
            </div>

            <style>{`* { box-sizing: border-box; margin: 0; padding: 0; }`}</style>
        </div>
    );
}
